import { render, staticRenderFns, recyclableRender, components } from "./approval.vue?vue&type=template&id=af051ce4&scoped=true&"
var renderjs
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"
import style0 from "./approval.vue?vue&type=style&index=0&id=af051ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af051ce4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/company/approval.vue"
export default component.exports